/**
 * Extracts the filename from a Content-Disposition header.
 * Prefers `filename*=UTF-8''…`, then quoted `filename="…"`, then unquoted `filename=…`.
 */
export function parseContentDispositionFilename(header: string | null | undefined): string | null {
  if (!header) return null

  const star = header.match(/filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/i)
  if (star) {
    try {
      const decoded = decodeURIComponent(star[1].trim()).trim()
      if (decoded) return decoded
    } catch {
      // malformed escape sequence: fall through to the plain forms
    }
  }

  const quoted = header.match(/filename\s*=\s*"([^"]*)"/i)
  if (quoted) {
    const name = quoted[1].trim()
    if (name) return name
  }

  const plain = header.match(/filename\s*=\s*([^;]+)/i)
  if (plain) {
    const name = plain[1].trim()
    if (name) return name
  }

  return null
}
